module.exports = __webpack_public_path__ + "img/770.3f82b88f.jpg";